import {MouseEventHandler} from 'react';

import {omit} from 'ramda';

import {Nullish, TestIdProps} from 'shared/web';

import {Button, ButtonProps} from '../../Button/Button';
import {Tooltip} from '../../Tooltip/Tooltip';

export interface ButtonActionProps extends Omit<ButtonProps, 'type'>, TestIdProps {
  type: 'button';
  title: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  buttonType?: ButtonProps['type'];
  tooltip?: string | Nullish;
}

export function ButtonAction(props: ButtonActionProps) {
  const buttonProps = withoutType(props);

  return (
    <Tooltip label={props.tooltip ?? undefined} shouldWrapperStretch={props.isFullWidth}>
      <Button {...buttonProps} data-testid={props['data-testid']} type={props.buttonType} />
    </Tooltip>
  );
}

const withoutType = omit(['type']);
